import React from "react";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Stepper from "@material-ui/core/Stepper";
import NextIcon from "@material-ui/icons/ArrowDownwardRounded";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";

import Step1 from "./steps/setMode";
import Step2 from "./steps/setDate";
import Step3 from "./steps/setUserInfo";
import Step4 from "./steps/payment";
import Button from "@material-ui/core/Button";

export class Reserve extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 0,
      step: 0,
      stepsTitle: [
        "انتخاب دوره",
        "انتخاب زمان",
        "وارد کردن اطلاعات",
        "پرداخت",
      ],
      data: {
        step1: {},
        step2: {},
        step3: {},
        step4: {},
      },
      isActive: false
    };

    this.stepsComponent = [
      <Step1 SubmitData={this.HandleData} modeSet={this.changeMode} />,
      <Step2
        mode={this.GetMode}
        ActivateNext={this.ActivateNextOne}
        SubmitData={this.HandleData}
        GoBack={this.PreviousStep}
      />,
      <Step3
        mode={this.GetMode}
        SubmitData={this.HandleData}
        ActivateNext={this.ActivateNextOne}
        GetStepData={this.getStepData} />,
      <Step4
        GetStepData={this.getStepData}
        GoBack={this.PreviousStep}
        ActivateNext={this.ActivateNextOne}
      />,
    ];
  }

  stepsComponent = [];

  ActivateNextOne = b => this.setState({
    isActive: b
  });

  getStepData = (step) => {
    return this.state.data[`step${step}`];
  }

  HandleData = (stepData, step) => {
    const allData = this.state.data;
    allData[step] = stepData;
    this.setState({
      data: allData,
    });
  };

  GetMode = () => this.state.mode;

  HandleSubmit() {
  }

  changeMode = (newMode) => {
    this.setState({
      mode: newMode,
      isActive: true
    });
  };

  NextStep = () => {
    if (this.state.step <= this.stepsComponent.length) {
      this.setState({
        step: this.state.step + 1,
      });
    }
  };

  PreviousStep = () => {
    if (this.state.step > 0) {
      this.setState({
        step: this.state.step - 1,
      });
    }
  };

  render() {
    return (
      <>
        <Card
          className="col-lg-8 mr-auto ml-auto shadow-sm rounded-lg"
        >
          <CardContent>
            <Stepper activeStep={this.state.step} orientation="vertical">
              {this.stepsComponent.map((Component, index) => {
                return (
                  <Step key={`STEP-${index}`}>
                    <StepLabel>{this.state.stepsTitle[index]}</StepLabel>
                    <StepContent>
                      {Component}
                      <Button variant={'contained'} onClick={this.NextStep} color="secondary" disabled={!this.state.isActive}>
                        مرحله بعد
                        <NextIcon fontSize={'small'} color={!this.state.isActive ? "disabled" : "inherit"} />
                      </Button>
                      {/*<IconButton onClick={this.NextStep} color="secondary" disabled={!this.state.isActive}>*/}
                      {/*  <NextIcon color={!this.state.isActive ? "disabled" : "secondary"} />*/}
                      {/*</IconButton>*/}
                    </StepContent>
                  </Step>
                );
              })}
            </Stepper>
          </CardContent>
        </Card>
      </>
    );
  }
}

export default Reserve;
